import * as Scrivito from "scrivito"
import { ArrayElement } from "shared/types/ArrayElement"
import { IconName } from "shared/ui/icon/__generated__/IconName"

export const BENEFITS_WIDGET_ICONS = [
  IconName.QUESTION,
  IconName.CLOSE,
  IconName.CHECK
] as const

export type BenefitsWidgetIcon = ArrayElement<typeof BENEFITS_WIDGET_ICONS>

export function isBenefitsWidgetIcon(
  value: unknown
): value is BenefitsWidgetIcon {
  return BENEFITS_WIDGET_ICONS.some(icon => icon === value)
}

export const BenefitIconWidget = Scrivito.provideWidgetClass(
  "BenefitIconWidget",
  {
    attributes: {
      icon: ["enum", { values: BENEFITS_WIDGET_ICONS }]
    }
  }
)

export type BenefitIconWidgetType = InstanceType<typeof BenefitIconWidget>
